import React, { useMemo } from 'react';
import { InnerLayout } from '@layout';
import Person, { PeopleWrapper } from '@components/Person';
import { H2 } from '@heading';
import RawHTML from '@components/RawHTML';
import styles from './PeopleList.module.scss';
import classNames from 'classnames';

export default function PeopleList(props) {
  const { sections = [] } = props.data?.markdownRemark?.frontmatter;

  const peopleSections = useMemo(
    () =>
      sections.map((section, index) => {
        const peopleData = section.people ?? [];

        return (
          <section
            key={index}
            className={styles.section}
          >
            <H2>{section.title}</H2>
            <RawHTML>{section.text_md}</RawHTML>
            <PeopleWrapper className={classNames(styles.people)}>
              {peopleData.map((p, index) => (
                <Person
                  key={index}
                  hasShadow={!!section.showShadows}
                  showPhoto={!!section.showPhotos}
                  slug={!!p?.html?.trim() ? p?.fields.slug : null}
                  {...p?.frontmatter}
                />
              ))}
            </PeopleWrapper>
          </section>
        );
      }),
    [sections]
  );

  return (
    <InnerLayout>
      <RawHTML>{props.data?.markdownRemark?.html}</RawHTML>
      {peopleSections}
    </InnerLayout>
  );
}
